import { isUrlValid } from './helper-functions';
document.documentElement.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
        return;
    }
    const linkArea = target.closest('.wwb-link-area');
    if (!linkArea) {
        return;
    }
    const elementWithLinkData = linkArea.closest('[data-wwb-link-url]');
    if (!(elementWithLinkData instanceof HTMLElement)) {
        return;
    }
    const linkUrl = elementWithLinkData.dataset.wwbLinkUrl;
    if (!linkUrl || !isUrlValid(linkUrl)) {
        return;
    }
    window.open(linkUrl, '_self');
});
